import { TCoursePacketType } from '../CoursePacket.types';

export const CheckIconColorMap: Record<TCoursePacketType, string> = {
  express: '#4088F4',
  basic: '#3C43F5',
  advanced: '#652AC6',
};
